/**
 * InvestmentWidget
 *
 * Dashboard widget that displays the investment account balance card.
 * Self-contained - fetches its own data.
 */
import { useParams } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import { Box, Paper, Typography, LinearProgress } from '@mui/material'
import { TrendingUp } from '@mui/icons-material'

import { queries } from '../../../graphql'
import { Amount } from '../../amount/amount'

export function InvestmentWidget({ fundId: propFundId }) {
  const { fundId: paramFundId } = useParams()
  const fundId = propFundId || paramFundId

  const { data, loading, error } = useQuery(queries.funds.myFund, {
    skip: !fundId,
    variables: { fundId: parseInt(fundId, 10) },
  })

  const fund = data?.me?.fund

  if (loading) {
    return <LinearProgress />
  }

  if (error || !fund) {
    return (
      <Paper sx={{ p: 3 }}>
        <Typography color="text.secondary">No fund data available</Typography>
      </Paper>
    )
  }

  return (
    <Paper sx={{ p: 3, height: '100%' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
        <Box
          sx={{
            p: 1.5,
            borderRadius: 2,
            bgcolor: 'success.light',
            color: 'success.main',
            display: 'flex',
          }}
        >
          <TrendingUp />
        </Box>
        <Typography variant="h6">Investment Account</Typography>
      </Box>
      <Typography variant="h4" fontWeight={600}>
        <Amount value={fund.investmentWalletBalance || 0} />
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        Growing for future giving
      </Typography>
    </Paper>
  )
}
